import { render, staticRenderFns } from "./Webinar.vue?vue&type=template&id=6d84b20d&scoped=true&"
import script from "./Webinar.vue?vue&type=script&lang=js&"
export * from "./Webinar.vue?vue&type=script&lang=js&"
import style0 from "./Webinar.vue?vue&type=style&index=0&id=6d84b20d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84b20d",
  null
  
)

export default component.exports